<template>
  <div class="px-3">
    <v-card-text class="pb-0">
      <v-form ref="formRef">
        <v-layout
            v-if="(!extendConvertVisaDetail.is_reciprocity) || (extendConvertVisaDetail.is_reciprocity && today_date > extendConvertVisaDetail.expiry_date)"
            row wrap>
          <form-error-display-handler :errors="errors"/>
          <v-flex xs12>
            <v-alert outlined
                     type="info" v-if="borderCaseReachedDay > 0">
              {{
                borderCaseReachedDay > 0 ? 'This is border case. You will get ' + borderCaseReachedDay + ' days visa free and cost of ' + (parseInt(extendConvertData.days_staying) - borderCaseReachedDay) + ' days' : ''
              }}
              <br>
            </v-alert>
            <v-alert
                outlined
                type="info"
                v-if="cost">
              Your visa cost will be <strong>USD($){{ cost }}</strong> with
              <strong>{{ plan }}</strong>
            </v-alert>

            <v-alert
                outlined
                type="info"
                v-if="visaSlug === 'tourist-visa' && remaining_days > 0">
              Your stay on this visa year ({{ currentVisaYear() }}) is {{ stay_days }} days and remaining days is
              {{ remaining_days }}. Your visa can extended upto <strong>{{ maxExpiryDate() }}</strong>
            </v-alert>
            <v-alert
                outlined
                type="info"
                v-if="visaSlug === 'tourist-visa' && remaining_days <= 0">
              Your stay on this visa year ({{ currentVisaYear() }}) is {{ stay_days }} days and remaining days is 0. Your visa cannot be extended.Please apply through overstay regulation.
            </v-alert>
            <v-alert
                type="error"
                v-if="!selected_day && extendConvertData.days_staying"
            >
              You cannot apply for {{ extendConvertData.days_staying }} days for this visa.
              Please contact immigration officer for further information
            </v-alert>
            <v-alert
                type="error"
                v-if="!extend_condition.length">
              No visa categories found for your document type {{ extendConvertVisaDetail.document_type }}. Please
              consult with Department of Immigration
            </v-alert>
            <late-info-message :cost="cost"/>
          </v-flex>
          <v-flex xs12>
            <v-alert
                type="error"
                v-if="checkIfApplicantsApplicableForAgeCondition == 0">
              Sorry, you cannot apply for the selected condition. Because your age is {{ getAge() }} and doesn't fall
              under the age group.
            </v-alert>
          </v-flex>
          <v-flex xs12 v-if="showAppointment">
            <appointment-date-picker v-model="extendConvertData.appointment_date"
                                     :type="selected_visa_type"/>
          </v-flex>

          <v-flex v-if="selected_visa_type === 'dependent-visa'" xs12 class="mt-4">
            <v-select
                :items="dependent_visa_options"
                label="Visa types for dependent"
                :rules="[rules.required]"
                item-text="type"
                item-value="id"
                min="0"
                outlined
                v-model="extendConvertData.extend_visa_type"
                @change="getConditionForDependent"
            />
          </v-flex>
          <v-flex xs12 v-if="!fetchedConditionForBorderCase">
            <v-select
                :items="extend_condition"
                :label="condition_label"
                :rules="[rules.required]"
                item-text="name"
                item-value="id"
                min="0"
                outlined
                v-model="extendConvertData.condition"
            />
          </v-flex>
          <v-flex xs12 v-if="fetchedConditionForBorderCase">
            <v-select
                :items="extend_condition"
                :label="condition_label"
                :rules="[rules.required]"
                item-text="name"
                item-value="id"
                min="0"
                outlined
                v-model="extendConvertData.condition"
            />
          </v-flex>
          <v-flex xs12 v-if="fetchedConditionForBorderCase">
            <v-select
                :items="border_case_extend_condition"
                :label="condition_label"
                :rules="[rules.required]"
                item-text="name"
                item-value="id"
                min="0"
                outlined
                v-model="extendConvertData.border_condition"
            />
          </v-flex>

          <v-flex xs12
                  v-if="isDependent && !['dependent-diplomatic-visa','dependent-official-visa'].includes(visaSlug)">
            <v-checkbox :value=1 v-model="extendConvertData.isIndianHost" label="Is Host Indian/Nepali?"></v-checkbox>
          </v-flex>
          <v-flex xs12 md4 v-if="isDependent">
            <v-autocomplete
                :items="relationship_options"
                :rules="[rules.required]"
                label="Relation with Host * "
                outlined
                v-model="visa.extra.application_data.relation"
            />
          </v-flex>

          <v-flex xs12 md4 px-2
                  v-if="isDependent && !['dependent-diplomatic-visa','dependent-official-visa'].includes(visaSlug) && extendConvertData.isIndianHost !== 1">
            <v-text-field
                label="Host visa number/Submission no * "
                :rules=[rules.required]
                outlined
                v-model="extendConvertData.extend_dependent_visa_number"
            />

          </v-flex>
          <v-flex xs12 md4 px2 v-if="isDependent">
            <v-text-field
                label="Host passport number "
                :rules=[rules.required]
                outlined
                class="px-2"
                v-model="extendConvertData.extend_dependent_passport_number"
            />
          </v-flex>


          <v-flex xs12 sm12 md4>
            <v-autocomplete
                :items="reason_for_extension"
                :label="$vuetify.lang.t('$vuetify.reason_for_extend') + ' *'"
                :rules=[rules.required]
                outlined
                v-model="extendConvertData.purpose_of_visa"
            />
          </v-flex>

          <v-flex xs12 sm12 md4 class="pl-2">
            <v-text-field
                label="Mobile number in Nepal *"
                :rules=[rules.required,rules.mobileNumberLength]
                outlined
                type="number"
                v-model="extendConvertData.mobile_number"
            />
          </v-flex>
          <v-flex xs12 sm12 md4 class="pl-2">
            <v-text-field
                :label="$vuetify.lang.t('$vuetify.email_required')"
                :rules="[rules.required, rules.email]"
                id="email"
                outlined
                type="email"
                autocomplete="off"
                placeholder="Application notification will be sent to this email"
                v-model="extendConvertData.email"
            />
          </v-flex>
          <v-flex xs12 sm12 md4>
            <date-picker-new
                :min-year="2000"
                class="pl-3 pr-4"
                :for-passport="true"
                :for-processing="true"
                v-model="extendConvertData.start_date"
                :watch-value="true"
                :disabled="true"
                label="Visa Start Date: Day* "
            />
          </v-flex>

          <v-flex xs12 sm12 md4
                  :class="{'pl-0': $vuetify.breakpoint.smAndDown, 'pl-2': $vuetify.breakpoint.mdAndUp}"
          >
            <v-text-field
                :rules="[rules.required]"
                :label="$vuetify.lang.t('$vuetify.days_staying') +' *'"
                min="0"
                onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
                outlined
                type="number"
                v-model="extendConvertData.days_staying"
            />
          </v-flex>
          <v-flex xs12 sm12 md4
                  :class="{'pl-0': $vuetify.breakpoint.smAndDown, 'pl-2': $vuetify.breakpoint.mdAndUp}">
            <v-text-field
                :rules="[rules.required]"
                label="Visa Expiry Date *"
                min="0"
                outlined
                type="text"
                :disabled="true"
                :value="expiryDate"
            />
          </v-flex>
          <v-flex xs12>
            <v-flex v-if="viewData.show_sre||viewData.show_mre" xs12>
              <v-radio-group row v-model="extendConvertData.visaPlan">
                <v-radio :value="1" label="Apply with Plain"
                         v-if="viewData.show_sre"/>
                <v-radio :value="2" label="Apply with SRE (Single Re-entry)"
                         v-if="viewData.show_sre && selected_visa_type !== 'tourist-visa'"/>
                <v-radio :value="3" label="Apply with MRE (Multiple Re-entry)"
                         v-if="viewData.show_mre"/>
              </v-radio-group>
            </v-flex>
          </v-flex>

          <v-flex v-if="message" xs12>
            <v-alert
                outlined
                type="info">{{ message }}
            </v-alert>
          </v-flex>

          <v-flex xs12>
            <component v-bind:is="selected_visa_type" :for-processing="true"/>
          </v-flex>
        </v-layout>

        <documents
            v-if="(!extendConvertVisaDetail.is_reciprocity) || (extendConvertVisaDetail.is_reciprocity && today_date > extendConvertVisaDetail.expiry_date)"
            :documents="documents" headerText="Documents to submit"/>

	      <attach-documents :documents="documents" headerText="Attach Documents" class="mx-3 mt-3"/>

	      <v-flex xs12 v-if="extendConvertVisaDetail.is_reciprocity && today_date < extendConvertVisaDetail.expiry_date">
          <v-alert class="mb-7"
                   outlined
                   type="info"
          >
            This is reciprocity visa.No need to do any form fill up for extension of reciprocity visa. All the setup
            will be done by administration section.
          </v-alert>
        </v-flex>

	      <v-flex xs12>
		      <v-checkbox
				      v-model="agree_terms_and_conditions"
				      label="I hereby declare that the submitted data and documents herein is true and accurate, and if found false, I am aware that I may be liable for it and bear legal consequences."
		      ></v-checkbox>
	      </v-flex>

        <v-flex class="d-flex" xs12>
          <v-spacer></v-spacer>
          <v-btn
              @click="back"
              color="error"
              dark
              large
          >{{ $vuetify.lang.t('$vuetify.back') }}
          </v-btn>
          <v-btn
              :disabled="(!extend_condition.length || checkIfApplicantsApplicableForAgeCondition == 0) || (!selected_day && extendConvertData.days_staying) || (maxExpiryDate() && expiryDate > maxExpiryDate() && visaSlug === 'tourist-visa') || (remaining_days  <= 0 && visaSlug === 'tourist-visa') || !agree_terms_and_conditions"
              class=" ml-2"
              @click="proceedConfirm"
              large
              color="primary">
            {{ $vuetify.lang.t('$vuetify.proceed') }}
          </v-btn>
        </v-flex>
      </v-form>

    </v-card-text>
  </div>
</template>

<script>
import ToolBar from "../../components/ToolBar";
import {mapActions, mapGetters} from 'vuex';

import TouristVisa from "../../components/visa/form/TouristVisa";
import StudyVisa from "../../components/visa/form/StudyVisa";
import MarriageVisa from "../../components/visa/form/MarriageVisa";
import NRNVisa from "../../components/visa/form/NRNVisa";
import OfficialVisa from "../../components/visa/form/OfficialVisa";
import RelationVisa from "../../components/visa/form/RelationVisa";
import ResidentialVisa from "../../components/visa/form/ResidentialVisa";
import WorkingVisa from "../../components/visa/form/WorkingVisa";
import PressVisa from "../../components/visa/form/PressVisa";
import BusinessVisa from "../../components/visa/form/BusinessVisa";
import FileInput from "../../components/FileInput";
import {validationMixin} from "../../mixins/validationMixin";
import LateInfoMessage from "../../components/LateInfoMessage";
import {fetchDynamicValues} from "../../helpers/dynamicValueHelper";
import moment from "moment"
import DatePickerNew from "../../components/DatePickerNew";
import HeaderText from "../../components/HeaderText";
import ConfirmationHeaderText from "../../components/ConfirmationHeaderText";
import AppointmentDatePicker from "../../components/AppointmentDatePicker";
import Documents from "../../components/Documents";
import Http from 'axios'
import {API_URL, VERSION} from "../../config/config";
import DependentVisa from "../../components/visa/form/DependentVisa";
import {VISA_PLANS} from "../../constant/appConstant";
import FormErrorDisplayHandler from "../../components/FormErrorDisplayHandler";
import AttachDocuments from "../../components/AttachDocuments";

export default {
  name: "ExtendForm",
  components: {
	  AttachDocuments,
    AppointmentDatePicker,
    DatePickerNew,
    ToolBar,
    TouristVisa,
    StudyVisa,
    MarriageVisa,
    'nrn-visa': NRNVisa,
    OfficialVisa,
    RelationVisa,
    ResidentialVisa,
    WorkingVisa,
    PressVisa,
    BusinessVisa,
    FileInput,
    LateInfoMessage,
    HeaderText,
    ConfirmationHeaderText,
    Documents, DependentVisa,
    FormErrorDisplayHandler
  },
  data() {
    return {
      invalid_date: false,
      show_sre: null,
      show_mre: null,
      selectedPlan: null,
      visa_plans: VISA_PLANS,
      reason_for_extension: [],
      existing_token: null,
      errors: [],
      relationship_options: [],
      fetchedConditionForBorderCase: false,
      borderCaseReachedDay: 0,

      today_date: moment().format('YYYY-MM-DD'),
	    agree_terms_and_conditions: false,
    }
  },
  mixins: [validationMixin],
  methods: {
    ...mapActions({fetchConditionsForExtend: 'VisaType/fetchConditionsForExtend'}),
    ...mapActions({fetchBorderCaseConditionsForExtend: 'VisaType/fetchBorderCaseConditionsForExtend'}),
    getConditionForDependent() {
      this.$store.dispatch('VisaType/fetchConditionForDependentExtend', this.extendConvertData.extend_visa_type).then((res) => {
        if (res.length === 1) {
          this.extendConvertData.condition = res[0].id
        }
      })
    },
    async proceedConfirm() {
      if (this.$refs.formRef.validate()) {
        if (this.extendConvertVisaDetail.late_days > this.extendConvertData.days_staying) {
          this.$store.commit('Notification/showError', 'You need to apply for ' + this.extendConvertVisaDetail.late_days + ' minimum days');
          return;
        }


        this.extendConvertData.plan_name = this.plan;
        this.extendConvertData.plan = this.extendConvertData.visaPlan;
        this.extendConvertData.documents = this.documents;
        this.extendConvertData.cost = this.cost;
        this.extendConvertData.expiry_date = this.expiryDate;

        if (this.showAppointment) {
          const selected_office = this.offices.find(i => i.slug === this.$store.state.VisaSingle.office)

          const {data: {status}} = await Http.get(`${API_URL}${VERSION}/check-if-time-available`, {
            params: {
              date: this.extendConvertData.appointment_date,
              type: this.extendConvertVisaDetail.slug,
              passport_number: this.extendConvertVisaDetail.passport_number,
              office: selected_office.slug
            }
          }).catch((error) => {
            this.errors = error.response.data.errors;
            this.$store.commit('Notification/showError', error.response.data.message)
          })
          if (!status) {
            this.$store.commit('Notification/showError', 'Visa appointment are already packed for this date .  Please select different date')
          } else {
            this.$router.push({
              name: 'ExtendConfirm'
            })
          }
        } else {
          if (this.extendConvertData.extend_dependent_passport_number) {
            try {
              await Http.get(`${API_URL}${VERSION}/can-apply-dependent`, {
                params: {
                  visa_number: this.extendConvertData.extend_dependent_visa_number,
                  passport_number: this.extendConvertData.extend_dependent_passport_number,
                  days_staying: this.extendConvertData.days_staying
                }
              })
              this.$router.push({
                name: 'ExtendConfirm'
              })
            } catch (e) {
              this.$store.commit('Notification/showError', e.response.data.message)
            }
          } else {
            this.$router.push({
              name: 'ExtendConfirm'
            })
          }
        }
      }
    },

    back() {
      this.$router.go(-1);
    },
    getAge() {
      var years = moment().diff(this.extendConvertVisaDetail.dob, 'years')
      return years;
    },
    maxExpiryDate() {
      const lastExpiryDate = this.extendConvertVisaDetail.expiry_date
          ? moment(this.extendConvertVisaDetail.expiry_date)
          : moment();

      const daysToAdd = this.remaining_days > 0 ? this.remaining_days : this.stay_days;

      return lastExpiryDate.add(daysToAdd, 'days').format('YYYY-MM-DD');
    },
    currentVisaYear() {
      return moment().format('YYYY')
    },
  },
  async updated() {
    const current_token = this.extendConvertVisaDetail.access_token;
    if (this.existing_token !== current_token) {
      // await this.$store.dispatch('VisaType/fetchConditionsForExtend');

      this.existing_token = current_token;
    }
  },
  computed: {
    ...mapGetters('VisaType', ['conditions', 'extend_condition', 'remaining_days', 'border_case_extend_condition', 'visa_type_slug', 'old_visa', 'stay_days']),
    ...mapGetters('VisaSingle', ['convert_visa_options', 'extendConvertVisaDetail', 'visa']),
    checkIfApplicantsApplicableForAgeCondition() {
      if (this.borderCaseReachedDay > 0) {
        return 1;
      }
      let conditions = this.fetchedConditionForBorderCase && this.border_case_extend_condition.length > 0 ? this.border_case_extend_condition : this.conditions;
      let selected_condition = conditions.find((c) => {
        if (this.fetchedConditionForBorderCase && this.border_case_extend_condition.length > 0) {
          return c.id === this.extendConvertData.border_condition;
        } else {
          return c.id === this.extendConvertData.condition;
        }
      });
      if (selected_condition && selected_condition.age) {
        let ageGroup = selected_condition.age.split('-');
        if (parseInt(ageGroup[0]) <= this.getAge() && this.getAge() < parseInt(ageGroup[1])) {
          return 1;
        } else {
          return 0;
        }
      }
      return 1;
    },
    dependent_visa_options() {
      let dependent_visa_options = this.$store.state.VisaSingle.convert_visa_options.filter(item => item.dependent);
      const office_name = this.$store.state.VisaSingle.office.toLowerCase();
      if (office_name === 'doi') {
        return dependent_visa_options;
      }
      const pokhara_office_options = ['relation-visa', 'nrn-visa', 'marriage-visa']
      return dependent_visa_options.filter((i) => pokhara_office_options.indexOf(i.slug) > -1);
    },
    extendConvertData() {
      return this.$store.state.VisaSingle.extendConvertData;
    },
    expiryDate() {
      return moment(this.extendConvertData.start_date).add(this.extendConvertData.days_staying, 'days').subtract(1, 'days').format('YYYY-MM-DD');
    },

    offices() {
      return this.$store.state.Office.offices;
    },
    showAppointment() {
      const selected_office = this.offices.find(i => i.slug === this.$store.state.VisaSingle.office)
      return selected_office.token_system_active;
    },
    condition_label() {
      let dependent_visa = this.extendConvertVisaDetail.dependent_visa ? "Dependent visa" : this.extendConvertVisaDetail.visa_type;

      return "Available condition for " + dependent_visa + " *"
    },
    documents() {
      if (this.extendConvertData.condition) {
        let selected_condition = this.extend_condition.find((i) => i.id === this.extendConvertData.condition);

        if (selected_condition)
          return selected_condition.documents;
      }
      return [];
    },
    isDependent() {
      return this.selected_visa_type.includes('dependent');
    },
    visaSlug() {
      return this.extendConvertVisaDetail.slug;

    },
    plan() {
      if (this.extendConvertData.apply_extend_gratis)
        return "Multiple Re-entry";

      if (!this.extendConvertData)
        return false;

      if (!this.extendConvertData.visaPlan)
        return false;

      return this.visa_plans.find((i) => i.key === parseInt(this.extendConvertData.visaPlan)).value;
    },
    cost() {
      if (!this.selected_day)
        return null;

      //if traveller dob after selected days >= maxAge of condition then fetch condition with new dob

      //subtracted selected days from traveller dob and get age
      let age = moment(this.extendConvertData.start_date).diff(moment(this.extendConvertVisaDetail.dob).subtract(parseInt(this.extendConvertData.days_staying), 'days').format('YYYY-MM-DD'), 'years');

      //condition fetched age
      if (this.extend_condition && this.extend_condition.length == 0) {
        return "0";
      }
      let selectedConditionAge = this.extend_condition[0].age;

      let selectedConditionAgeArray = selectedConditionAge.split('-');
      var maxAge = selectedConditionAgeArray[selectedConditionAgeArray.length - 1];


      var condition = this.extend_condition.find(i => i.id === this.extendConvertData.condition);

      var isGratis = true;
      if (condition !== undefined) {
        const days = condition.days;
        for (let i = 0; i < days.length; i++) {
          if (parseInt(days[i].cost) > 0) {
            isGratis = false
            break;
          }
        }
      }
      //calculation for border days;
      let dobwithmaxage = moment(this.extendConvertVisaDetail.dob).add(parseInt(maxAge), 'years')
      //removed +1 as per said by suraj prakash aryal
      var borderFreeDays = dobwithmaxage.diff(moment(this.extendConvertData.start_date), "days");

      if (isGratis && borderFreeDays >= 0 && selectedConditionAge && age >= parseInt(maxAge)) {
        if (!this.fetchedConditionForBorderCase) {
          this.borderCaseReachedDay = borderFreeDays;
          this.$store.state.VisaType.borderCaseReachedDay = borderFreeDays;
          console.log(parseInt(this.extendConvertData.days_staying));
          console.log(moment(this.extendConvertVisaDetail.dob).subtract(parseInt(this.extendConvertData.days_staying) - 1, 'days').format('YYYY-MM-DD'));
          let dob = moment(this.extendConvertVisaDetail.dob).subtract(parseInt(this.extendConvertData.days_staying) - 1, 'days').format('YYYY-MM-DD')
          this.fetchBorderCaseConditionsForExtend(dob);
          this.fetchedConditionForBorderCase = true;
        }
      } else {
        // dob +upperlimit < visa_start_date
        if (this.extendConvertData.days_staying === "" || parseInt(this.extendConvertData.days_staying) < this.borderCaseReachedDay) {
          this.$store.commit('VisaType/setBorderCaseExtendConditions', [])
          this.fetchedConditionForBorderCase = false;
          this.borderCaseReachedDay = 0;
        }
      }


      const selected_plan = parseInt(this.extendConvertData.visaPlan);
      const selected_day_plan = parseInt(this.selected_day.plan);

      if (this.extendConvertData.apply_extend_gratis) {
        return "0";
      }

      if (selected_plan !== selected_day_plan) {
        if (selected_plan === 2)
          return parseInt(this.selected_day.cost) + parseInt(this.extendConvertVisaDetail.sre_cost);

        if (selected_plan === 3)
          return parseInt(this.selected_day.cost) + parseInt(this.extendConvertVisaDetail.mre_cost);

      }

      if (this.extendConvertVisaDetail.dependent_visa) {
        return this.selected_day.cost;
      }

      return this.selected_day.cost;

    },
    viewData() {
      let show_sre = null;
      let show_mre = null;
      if (this.selected_day && !this.extendConvertData.apply_extend_gratis) {
        let visa_plan = parseInt(this.selected_day.plan);
        this.extendConvertData.visaPlan = visa_plan;
        if (visa_plan === 1) {
          show_sre = true;
          show_mre = true;
        } else if (visa_plan === 2) {
          show_mre = true;
        }
      }
      return {
        show_sre,
        show_mre
      }
    },
    selected_day() {
      let conditions = this.fetchedConditionForBorderCase && this.border_case_extend_condition.length > 0 ? this.border_case_extend_condition : this.extend_condition;
      let selected_condition = this.fetchedConditionForBorderCase && this.border_case_extend_condition.length > 0 ? this.extendConvertData.border_condition : this.extendConvertData.condition;
      if (selected_condition !== undefined && selected_condition) {
        let days_staying = this.extendConvertData.days_staying;
        selected_condition = conditions.find((i) => i.id === selected_condition);
        if (days_staying) {
          days_staying = this.borderCaseReachedDay > 0 ? parseInt(days_staying) - this.borderCaseReachedDay : parseInt(days_staying);
          let selected_day = false;
          let days = selected_condition.days;
          for (let i = 0; i < days.length; i++) {
            if (parseInt(days[i].days) >= days_staying) {
              selected_day = days[i];
              break;
            }
          }


          if (selected_day)
            return selected_day
        }
      }

      return false;
    },
    selected_visa_type() {
      if (this.extendConvertVisaDetail.dependent_visa) {
        return "dependent-visa"
      }

      return this.extendConvertVisaDetail.slug;
    },
    message() {
      const selected_condition = this.conditions.find((c) => c.id === this.extendConvertData.condition);
      if (selected_condition) {
        return selected_condition.extension_message;
      } else {
        return false;
      }
    },
  },
  async mounted() {
    this.extendConvertData.start_date = moment(this.extendConvertVisaDetail.expiry_date).add(1, 'days').format('YYYY-MM-DD');
    this.extendConvertData.email = this.extendConvertVisaDetail.email
    delete this.extendConvertData.overstay_processing;

    fetchDynamicValues('ReasonForExtension').then((data) => {
      this.reason_for_extension = data;
    });
    const default_selected_visa_type = this.dependent_visa_options.find(item => item.slug === this.extendConvertVisaDetail.slug);
    if (default_selected_visa_type !== undefined)
      this.extendConvertData.extend_visa_type = default_selected_visa_type.id


    if (this.isDependent)
      fetchDynamicValues('Relations').then((data) => {
        this.relationship_options = data;
      })
  },

}
</script>
